import { Route, Routes } from "react-router-dom";
import AdminHome from "../../components/admin/adminHome/AdminHome";
import Navbar from "../../components/admin/navbar/Navbar";
import styles from "./Admin.module.scss";
import Category from "../../components/admin/category/Category";
import Type from "../../components/admin/type/Type";
import AddPost from "../../components/admin/addPost/AddPost";
import ViewPosts from "../../components/admin/viewPosts/ViewPosts";
import EditPost from "../../components/admin/editPost/EditPost";
import AddAdds from "../../components/admin/advertisement/add/AddAdds";
import ViewAdds from "../../components/admin/advertisement/view/ViewAdds";
import EditAdd from "../../components/admin/advertisement/edit/EditAdd";
// import Coupon from "../../components/admin/coupon/Coupon";
// import Orders from "../../components/admin/orders/Orders";
// import OrderDetails from "../../components/admin/orders/OrderDetails";
import ViewUsers from "../../components/admin/viewUsers/ViewUsers";
import AddVote from "../../components/admin/addVote/AddVote";

const Admin = () => {
  return (
    <div className={styles.admin}>
      <div className={styles.navbar}>
        <Navbar />
      </div>
      <div className={styles.content}>
        <Routes>
          <Route path="home" element={<AdminHome />} />
          <Route path="category" element={<Category />} />
          <Route path="brand" element={<Type />} />

          <Route path="add-post" element={<AddPost />} />
          <Route path="all-posts" element={<ViewPosts />} />
          <Route path="edit-post/:id" element={<EditPost />} />

          <Route path="add-vote" element={<AddVote />} />
          {/* <Route path="all-votes" element={<ViewVotes />} /> */}
          {/* <Route path="edit-vote" element={<EditVote />} /> */}

          <Route path="add-adds" element={<AddAdds />} />
          <Route path="all-adds" element={<ViewAdds />} />
          <Route path="edit-add/:id" element={<EditAdd />} />

          <Route path="view-users" element={<ViewUsers />} />
        </Routes>
      </div>
    </div>
  );
};
export default Admin;
